import { createContext } from 'react'

export const WSOrders = createContext()
